import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { createApplication } from "@/api/v1-jwt/provider-onboarding/provider-onboarding";
import { CreateApplicationPayload, CreateApplicationResponse } from "./types";

interface CreateApplicationParams {
  userId: string;
  providerType: string;
  payload: CreateApplicationPayload;
}

export const useCreateApplication = (
  options?: UseMutationOptions<CreateApplicationResponse, Error, CreateApplicationParams>
) => {
  return useMutation<CreateApplicationResponse, Error, CreateApplicationParams>({
    mutationFn: ({ userId, providerType, payload }) =>
      createApplication(userId, providerType, payload),
    ...options,
  });
};
